<template>
  <div class="card-body">
    <div class="mb-3">
      <argon-input
        type="password"
        placeholder="New Password"
        name="newPassword"
        size="lg"
        v-model:value.sync="newPassword"
      />
    </div>
    <div class="mb-3">
      <argon-input
        type="password"
        placeholder="Confirm Password"
        name="confirmPassword"
        size="lg"
        v-model:value.sync="confirmPassword"
      />
    </div>
    <div class="text-center">
      <argon-button
        class="mt-4"
        variant="gradient"
        color="success"
        fullWidth
        size="lg"
        :isLoading="signInButtonClicked"
        :isLoadingText="'Sign In'"
        @click="SignIn"
        >Sign In</argon-button
      >
    </div>
  </div>
</template>

<script>
import { ArgonInput, ArgonButton } from "@/components/exporter.js";
import { Validator } from "@/customFunctions/Validator.js";
import { Toaster } from "@/customFunctions/Utils.js";
import { mapGetters } from "vuex";
import { SendPOSTUserAPI } from "@/customFunctions/Api.js";

export default {
  name: "inputs-container",
  components: {
    ArgonInput,
    ArgonButton,
  },
  data() {
    return {
      newPassword: "",
      confirmPassword: "",
      signInButtonClicked: false,
    };
  },
  computed: {
    ...mapGetters([
      "getUserEmail",
      "getUserPassword",
      "getAuth0PasswordPolicyEnabled",
    ]),
  },

  methods: {
    async SignIn() {
      this.signInButtonClicked = true;
      if (!this.Validate()) {
        this.signInButtonClicked = false;
        return;
      }

      try {
        const userApiResponse = await SendPOSTUserAPI(
          "users/change-password",
          null,
          {
            username: this.getUserEmail,
            currentPassword: this.getUserPassword,
            newPassword: this.newPassword,
          }
        );

        if (this.CheckConditions(userApiResponse)) {
          this.signInButtonClicked = false;
          return;
        }

        this.Toaster("Some Error...", "Error", "danger");
      } catch (e) {
        this.signInButtonClicked = false;
        console.log(e, "Change Password Sign In exception");
      }

      this.signInButtonClicked = false;
    },
    Validate() {
      Validator.validatePassword(this.newPassword);
      if (this.getAuth0PasswordPolicyEnabled) {
        Validator.validateStrongPassword(this.newPassword);
      }
      Validator.validateConfirmPassword(this.newPassword, this.confirmPassword);
      return !Validator.validateIfHasError(this.Toaster);
    },
    CheckConditions(userApiResponse) {
      if (userApiResponse.statusCode === 200) {
        this.$router.push({ path: "signin" });
        return true;
      }
      if (userApiResponse.message) {
        this.Toaster(userApiResponse.message, "Error", "danger");
        return false;
      }
      return false;
    },
  },
  setup() {
    return { Toaster };
  },
};
</script>
